import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import Auth from './modules/Auth'

// Import InterUI Font
import '../public/fonts/inter-ui.css'
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css'
// Import Main styles for this application
import '../scss/style.scss'

// Containers
import Full from './containers/Full/'

// Views
import Login from './views/Pages/Login/'
import ConfirmEmail from './views/Pages/ConfirmEmail/'
import ForgotPassword from './views/Pages/ForgotPassword/'
import ResetPassword from './views/Pages/ResetPassword/'
import Page404 from './views/Pages/Page404/'
import Page500 from './views/Pages/Page500/'

const PrivateRoute = ({ component: Full, ...rest }) => (
  <Route {...rest} render={props => (
    Auth.isUserAuthenticated() ? (
      <Full {...props}/>
    ) : (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }}/>
    )
  )}/>
)

ReactDOM.render((
  <Router>
    <Switch>
      <Route exact path="/login" name="Login Page" component={Login} />
      <Route exact path="/forgot-password" name="Forgot Password" component={ForgotPassword} />
      <Route exact path="/reset-password" name="Reset Password" component={ResetPassword} />
      <Route exact path="/confirm-email" name="Confirm E-Mail" component={ConfirmEmail} />
      <Route exact path="/404" name="Page 404" component={Page404} />
      <Route exact path="/500" name="Page 500" component={Page500} />
      <PrivateRoute path="/" name="Home" component={Full} />
    </Switch>
  </Router>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js